import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Info from '../../../assets/icons/info.png'
import { useEffect, useMemo, useRef, useState } from 'react'
import redirectURL from "../../redirectURL";
import moment from 'moment'
import CountUp from 'react-countup';
import Loader from '../../mainpage/Loader';
import DatePicker from 'react-datepicker'
import { fetchGridLayout, getDecoder, getHyphenDDMMMYYYYHHMM, saveGridLayout } from '../../common/utils';
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

export default function CreatedTripStatus() {

    const user = useMemo(() => getDecoder(), []);
    const status = useMemo(() => [["consignment_created", []], ["inside_plant", []], ["in_transit", []], ["reached_customer", []], ["left_customer", []], ["force_closed", []], ["cancelled", []], ["trip_closed", []]], []);
    const [show, setShow] = useState(false)
    const [type, setType] = useState('default')
    const [title, setTitle] = useState('')
    const [subCounter, setSubCounter] = useState('')
    const [subCounterCount, setSubCounterCount] = useState({ 0: 0, 30: 0, 3060: 0, 60: 0 })
    const gridColumnState = useRef(null)
    const columnApi = useRef(null)
    const chart1 = useRef(null)
    const chart2 = useRef(null)
    const chart3 = useRef(null)
    const chart4 = useRef(null)
    const [startDate, setStartDate] = useState(new Date(moment().startOf('month')));
    const [endDate, setEndDate] = useState(new Date(moment.parseZone()));
    const [loader, setLoader] = useState(false)
    const [rowData, setRowData] = useState([])
    const [tripData, setTripData] = useState({
        trip_creation: 0,
        trip_approved: 0,
        trip_auto_closure: 0,
        trip_non_auto_closure: 0,
        trip_cancelled: 0
    })
    const [allData, setAllData] = useState(new Map(status))
    const coloumnDefs = useMemo(() => {
        return [
            {
                headerName: "Plant Name",
                field: "consigner_name",
            },
            {
                headerName: "Plant Code",
                field: "consigner_code",
                width: 124
            },
            {
                headerName: "Trips Created(Enmovil)",
                field: "trips_created_enmovil",
            },
            // {
            //     headerName: "Consent Triggered",
            //     field: "consent_triggered",
            //     width: 165
            // },
            {
                headerName: "Consent Approved",
                field: "consent_approved",
                width: 165,
                valueGetter: function (params) {
                    return params.data.consent_approved_count + " (" + params.data.consent_approved + ")"
                },
                cellStyle: function (params) {
                    if (params.data.consent_approved != undefined && params.data.consent_approved != '') {
                        let temp = parseFloat(params.data.consent_approved.replace("%", ''))
                        if (temp < 90)
                            return { backgroundColor: "#ff90a3" }
                        else if (temp >= 90 && temp <= 100)
                            return { backgroundColor: "#00dea7" }
                    }
                }
            },
            {
                headerName: "Auto Closed",
                field: "auto_closed",
                width: 129,
                valueGetter: function (params) {
                    return params.data.auto_closed_count + " (" + params.data.auto_closed + ")"
                },
                cellStyle: function (params) {
                    if (params.data.auto_closed != undefined && params.data.auto_closed != '') {
                        let temp = parseFloat(params.data.auto_closed.replace("%", ''))
                        if (temp > 20)
                            return { backgroundColor: "#ff90a3" }
                        else if (temp <= 20 && temp >= 0)
                            return { backgroundColor: "#00dea7" }
                    }
                }
            },
            {
                headerName: "Reached Geofence",
                field: "non_auto_closed",
                width: 154,
                valueGetter: function (params) {
                    return params.data.non_auto_closed_count + " (" + params.data.non_auto_closed + ")"
                },
                cellStyle: function (params) {
                    if (params.data.non_auto_closed != undefined && params.data.non_auto_closed != '') {
                        let temp = parseFloat(params.data.non_auto_closed.replace("%", ''))
                        if (temp < 80)
                            return { backgroundColor: "#ff90a3" }
                        else if (temp >= 80 && temp <= 100)
                            return { backgroundColor: "#00dea7" }
                    }
                }
            },
            {
                headerName: "Cancelled",
                field: "cancelled",
                width: 134,
                valueGetter: function (params) {
                    return params.data.cancelled_count + " (" + params.data.cancelled + ")"
                },
            },
        ]
    }, [])
    const defaultColumnDef = useMemo(() => {
        return {
            sortable: true,
            filter: true,
            resizable: true
        }
    }, [])

    const submitEvent = (e) => {
        e.preventDefault()
        getData()
    }

    const onGridReady = async (params) => {
        await fetchGridLayout(user?.email, "closed_trip_summary")
            .then(async res => {
                if (res.data.status == "success" && Array.isArray(res.data.data[0].columnState) && res.data.data[0].columnState.length > 0) {
                    setTimeout(async () => {
                        await params.api.applyColumnState({
                            state: res.data.data[0].columnState,
                            applyOrder: true,
                        })
                    }, 1000);
                    gridColumnState.current = res.data.data[0].columnState
                }
            })
            .catch(err => console.log(err))
    };
    const saveGrid = async (e) => {
        let coloumnState = columnApi.current.api.getColumnState()
        let temp = await saveGridLayout(user.email, "closed_trip_summary", coloumnState)
        gridColumnState.current = coloumnState
        if (temp.data.status == "success") {
            setShow(true)
            setTitle("Grid successfully updated")
            setType("success")
        }
        else {
            setShow(true)
            setTitle("Failed to update grid")
            setType("danger")
        }
    }
    const resetGrid = async (e) => {
        let coloumnState = []
        let temp = await saveGridLayout(user.email, "closed_trip_summary", coloumnState)
        if (temp.data.status == "success") {
            setShow(true)
            setTitle("Grid successfully reset")
            setType("success")
            columnApi.current.api.resetColumnState()
        }
        else {
            setShow(true)
            setTitle("Failed to reset grid")
            setType("danger")
        }
    }
    const getRowStyle = (params) => {
        if (subCounter == "") {
            if (params.data.alert_color_amber == 1) {
                return { backgroundColor: '#ffbf00' };
            }
            if (params.data.alert_color_red == 1) {
                return { backgroundColor: '#FF8080' };
            }
            if (params.data.alert_color_dark_red == 1) {
                return { backgroundColor: '#FF4040' };
            }
        }
        else {
            if (subCounter === -1) {
                return { backgroundColor: '#FF4040' };
            }
            if (subCounter === 3060) {
                return { backgroundColor: '#ffbf00' };
            }
            if (subCounter === 30) {
                return { backgroundColor: '#FF8080' };
            }
        }
        return undefined;
    }
    const getData = async () => {
        setLoader(true)
        let params = {
            sdate: moment.parseZone(new Date(startDate)).format("YYYY-MM-DD"),
            edate: moment.parseZone(new Date(endDate)).format("YYYY-MM-DD")
        }
        await redirectURL.post("/dashboard/getTripsData", params)
            .then((response) => {
                let consignments = response.data.consignments
                let resultData = []
                if (response.data.status == "success" && Object.keys(consignments).length > 0) {
                    let trip_creation = 0
                    let trip_approved = 0
                    let trip_auto_closure = 0
                    let trip_non_auto_closure = 0
                    let trip_cancelled = 0
                    for (let key in consignments) {
                        let obj = {}
                        let consent_approved = 0
                        let auto_closed = 0
                        let non_auto_closed = 0
                        let cancelled = 0
                        let consigner_name = ''
                        consignments[key].forEach(each => {
                            if (each.hasOwnProperty('consigner_name'))
                                consigner_name = each.consigner_name
                            if (each.tracking_mode == "GPS") {
                                consent_approved = consent_approved + 1
                                if (each.status == 4 || each.status == 5)
                                    non_auto_closed = non_auto_closed + 1
                                else if ([6, 9].includes(each.status))
                                    auto_closed = auto_closed + 1
                                else if (each.status == 8)
                                    cancelled = cancelled + 1
                            }
                            else if ([3, 18, 4, 7, 12, 15, 16, 17, 19, 20, 21, 23, 24, 25, 26, 9].includes(each.sim_tracking_state)) {
                                consent_approved = consent_approved + 1
                                if (each.status == 4 || each.status == 5)
                                    non_auto_closed = non_auto_closed + 1
                                else if ([6, 9].includes(each.status))
                                    auto_closed = auto_closed + 1
                                else if (each.status == 8)
                                    cancelled = cancelled + 1
                            }
                        });
                        obj["consigner_code"] = key
                        obj["consigner_name"] = consigner_name
                        obj["trips_created_enmovil"] = consignments[key].length
                        // obj["consent_triggered"] = consignments[key].length
                        obj["consent_approved"] = parseFloat((consent_approved / consignments[key].length) * 100).toFixed(2) + "%"
                        obj["consent_approved_count"] = consent_approved
                        obj["auto_closed"] = isNaN(parseFloat((auto_closed / consent_approved) * 100).toFixed(2)) ? "0%" : (parseFloat((auto_closed / consent_approved) * 100).toFixed(2) + "%")
                        obj["auto_closed_count"] = auto_closed
                        obj["non_auto_closed"] = isNaN(parseFloat((non_auto_closed / consent_approved) * 100).toFixed(2)) ? "0%" : (parseFloat((non_auto_closed / consent_approved) * 100).toFixed(2) + "%")
                        obj["non_auto_closed_count"] = non_auto_closed
                        obj["cancelled"] = isNaN(parseFloat((cancelled / consent_approved) * 100).toFixed(2)) ? "0%" : (parseFloat((cancelled / consent_approved) * 100).toFixed(2) + "%")
                        obj["cancelled_count"] = cancelled
                        resultData.push(obj)
                        trip_creation = trip_creation + consignments[key].length
                        trip_approved = trip_approved + consent_approved
                        trip_auto_closure = trip_auto_closure + auto_closed
                        trip_non_auto_closure = trip_non_auto_closure + non_auto_closed
                        trip_cancelled = trip_cancelled + cancelled
                    }
                    setRowData(resultData)
                    setTripData({
                        trip_creation,
                        trip_approved,
                        trip_auto_closure,
                        trip_non_auto_closure,
                        trip_cancelled
                    })
                }
                setLoader(false)
            })
            .catch(function (e) {
                setLoader(false)
                console.log(e)
            })
    }
    useEffect(() => {
        getData()
    }, [])

    const handleStartDateChange = (date) => {
        if (endDate && date > endDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setStartDate(date)
        }
    };

    const handleEndDateChange = (date) => {
        if (startDate && date < startDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setEndDate(date)
        }
    };

    const onConfirm = () => {
        setShow(false);
        setTitle('')
        setType('default')
    };

    return (
        <div className="container-fluid" style={{ paddingLeft: "0px" }}>
            <SweetAlert
                show={show}
                title={<span style={{ fontSize: "1rem" }}>{title}</span>}
                onConfirm={onConfirm}
                confirmBtnBsStyle={type}
                confirmBtnCssClass="sweetButton"
                customClass='sweetWidth'
                type={type}>
            </SweetAlert>
            <Loader show={loader} />
            <h5 className="mb-15p fbold f20">
                <i className="fa fa-truck cus-i"></i><span style={{ fontWeight: "600" }}>  Closed Trip Summary</span>
            </h5>
            <div className="row">
                <div className="col-xl-3 col-lg-3 form-group">
                    <label>From Date</label>
                    <DatePicker
                        selected={startDate}
                        onChange={handleStartDateChange}
                        className="form-control"
                        autoComplete="off"
                        placeholderText="From date"
                        dateFormat="dd/MM/yyyy"
                    />
                </div>
                <div className="col-xl-3 col-lg-3 form-group">
                    <label>To Date</label>
                    <DatePicker
                        selected={endDate}
                        onChange={handleEndDateChange}
                        className="form-control"
                        autoComplete="off"
                        placeholderText="To date"
                        dateFormat="dd/MM/yyyy"
                    />
                </div>
                <div className={"col-xl-3 col-lg-3 form-group float-left"}>
                    <label></label><br />
                    <button type="button" onClick={submitEvent} className="btn btn-success mt-9p">Submit</button>
                </div>
            </div>
            <div className="beffect">
                <div className="card">
                    <div className="card-body row" style={{ padding: "14px" }}>
                        <div className="crm-numbers col-md-12 pb-0">
                            <div className="row">
                                <div className="col display-counter-flex-end">
                                    <h4 className="txt-secondary f24">
                                        <span className="counter">
                                            <CountUp end={tripData.trip_creation} />
                                        </span>
                                    </h4>
                                    <span className="f13">
                                        Trips Created(Enmovil)
                                    </span>
                                </div>
                                <div className="col display-counter-flex-end">
                                    <h4 className="darkblue f24">
                                        <span className="counter">
                                            <CountUp end={tripData.trip_approved} /> ({(isNaN(parseFloat((tripData.trip_approved / tripData.trip_creation) * 100)) ? 0 : parseFloat((tripData.trip_approved / tripData.trip_creation) * 100)).toFixed(1)}%)
                                        </span>
                                    </h4>
                                    <span className="f13">
                                        Trips Approved&nbsp;
                                        <OverlayTrigger
                                            placement="bottom"
                                            overlay={<Tooltip id="tooltip-example">Trips Created vs Trips Approved</Tooltip>}>
                                            <img src={Info} width="16px" style={{ position: "absolute" }} />
                                        </OverlayTrigger>
                                    </span>
                                </div>
                                <div className="col display-counter-flex-end">
                                    <h4 className="txt-primary f24">
                                        <span className="counter">
                                            <CountUp end={tripData.trip_auto_closure} /> ({isNaN(parseFloat((tripData.trip_auto_closure / tripData.trip_approved) * 100)) ? 0 : parseFloat((tripData.trip_auto_closure / tripData.trip_approved) * 100).toFixed(1)}%)
                                        </span>
                                    </h4>
                                    <span className="f13">
                                        Trip Closure (Auto Closure)&nbsp;
                                        <OverlayTrigger
                                            placement="bottom"
                                            overlay={<Tooltip id="tooltip-example">Trips Approved vs Auto Closure(Force Close, Trip Closure)</Tooltip>}>
                                            <img src={Info} width="16px" style={{ position: "absolute" }} />
                                        </OverlayTrigger>
                                    </span>
                                </div>
                                <div className="col display-counter-flex-end">
                                    <h4 className="f24" style={{ color: "#17b169" }}>
                                        <span className="counter">
                                            <CountUp end={tripData.trip_non_auto_closure} /> ({isNaN(parseFloat((tripData.trip_non_auto_closure / tripData.trip_approved) * 100)) ? 0 : parseFloat((tripData.trip_non_auto_closure / tripData.trip_approved) * 100).toFixed(1)}%)
                                        </span>
                                    </h4>
                                    <span className="f13">
                                        Trip Closure (Reached Geofence)&nbsp;
                                        <OverlayTrigger
                                            placement="bottom"
                                            overlay={<Tooltip id="tooltip-example">Trips Approved vs Reached Geofence(Reached Customer, Left Customer)</Tooltip>}>
                                            <img src={Info} width="16px" style={{ position: "absolute" }} />
                                        </OverlayTrigger>
                                    </span>
                                </div>
                                <div className="col display-counter-flex-end">
                                    <h4 className="f24" style={{ color: "#80c4e9" }}>
                                        <span className="counter">
                                            <CountUp end={tripData.trip_cancelled} /> ({isNaN(parseFloat((tripData.trip_cancelled / tripData.trip_approved) * 100)) ? 0 : parseFloat((tripData.trip_cancelled / tripData.trip_approved) * 100).toFixed(1)}%)
                                        </span>
                                    </h4>
                                    <span className="f13">
                                        Trip Cancelled&nbsp;
                                        <OverlayTrigger
                                            placement="bottom"
                                            overlay={<Tooltip id="tooltip-example">Trips Approved vs Trips Cancelled</Tooltip>}>
                                            <img src={Info} width="16px" style={{ position: "absolute" }} />
                                        </OverlayTrigger>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="">
                <div className="col card">
                    <div className="card-header pt-10px" >
                        {/* <div className="col-xl-12 col-lg-12 main-page-display"> */}
                        {/* <div style={{ display: 'flex', alignItems: "center" }}>
                                <h5>
                                    {counter}
                                </h5>
                            </div> */}
                        <div>
                            <span className="layoutbtns float-right">
                                <div className="col-sm-12" style={{ display: "flex", alignItems: "center" }}>
                                    <button type="button" title="Save Grid Layout" name="savegrid" className="btn btn-success float-right action_btn" style={{ marginLeft: "10px" }} onClick={saveGrid}> <i className="fa fa-save"></i> </button>
                                    <button type="button" title="Reset Grid Layout" name="resetgrid" className="btn btn-info float-right action_btn" style={{ marginLeft: "10px" }} onClick={resetGrid}> <i className="fa fa-reply"></i> </button>
                                </div>
                            </span>
                        </div>
                        {/* </div> */}
                    </div>
                    <div className="col-xl-12 col-lg-12">
                        <div className="row card-body pt-15px" >
                            <div id="myGrid" style={{ height: "550px", width: "100%" }} className="col-xl-12 col-lg-12 ag-theme-balham">
                                <AgGridReact
                                    ref={columnApi}
                                    columnDefs={coloumnDefs}
                                    defaultColDef={defaultColumnDef}
                                    rowData={rowData}
                                    enableCharts={true}
                                    enableRangeSelection={true}
                                    onGridReady={onGridReady}
                                    sideBar={{
                                        toolPanels: [
                                            {
                                                id: "columns",
                                                labelDefault: "Columns",
                                                labelKey: "columns",
                                                iconKey: "columns",
                                                toolPanel: "agColumnsToolPanel",
                                                toolPanelParams: {
                                                    suppressPivotMode: true,
                                                    suppressRowGroups: true,
                                                    suppressValues: true,
                                                }
                                            },
                                            {
                                                id: "filters",
                                                labelDefault: "Filters",
                                                labelKey: "filters",
                                                iconKey: "filter",
                                                toolPanel: "agFiltersToolPanel"
                                            }
                                        ]
                                    }}
                                    statusBar={{
                                        statusPanels: [
                                            {
                                                statusPanel: "agTotalAndFilteredRowCountComponent",
                                                align: "left"
                                            },
                                            {
                                                statusPanel: "agTotalRowCountComponent",
                                                align: "center"
                                            },
                                            { statusPanel: "agFilteredRowCountComponent" },
                                            { statusPanel: "agSelectedRowCountComponent" },
                                            { statusPanel: "agAggregationComponent" }
                                        ]
                                    }}
                                    paginationPageSize={100}
                                    pagination={true}
                                    masterDetail={true}
                                    suppressCellFlash={true}
                                    getRowStyle={getRowStyle}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

function dateComparator(date1, date2) {
    // console.log("dateComparator");
    // console.log(date1.length);
    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
        // console.log(date1,date2);
        var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
        date1 = date1.replace(date1.split(" ")[0].split("-")[1], date_1);
        var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
        date2 = date2.replace(date2.split(" ")[0].split("-")[1], date_2);
        // console.log(date1,date2);
        var date1Number = monthToComparableNumber(date1);
        var date2Number = monthToComparableNumber(date2);
        // console.log(date1Number,date2Number);
        if (date1Number === null && date2Number === null) {
            return 0;
        }
        if (date1Number === null) {
            return -1;
        }
        if (date2Number === null) {
            return 1;
        }
        return date1Number - date2Number;
    }
}


function monthToComparableNumber(date) {
    // console.log(date,date.length);
    if (date === undefined || date === null || date.length !== 16) {
        return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
}

function getMonthNumber(monthName) {
    var months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May',
        'Jun', 'Jul', 'Aug', 'Sep',
        'Oct', 'Nov', 'Dec'
    ];
    var monthNum = months.indexOf(monthName) + 1;
    if (monthNum < 10) {
        monthNum = "0" + monthNum.toString();
    }
    return monthNum;
}

function formatString(str) {
    return str
        .replace(/^./, (match) => match.toUpperCase()); // Capitalize the first letter
}